/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = RETAIL
 *
 * 2 = ASSOCIATE
 *
 * 3 = B2B
 *
 * 4 = MOTAB
 *
 * 5 = PARTNER
 *
 * 6 = TRADE
 *
 * 7 = AUCTION
 *
 * 8 = DEALERTRF
 *
 * 9 = VIP
 *
 * 10 = AGENCY
 */
export enum EnquiryTypes {
  RETAIL = 1,
  ASSOCIATE = 2,
  B2B = 3,
  MOTAB = 4,
  PARTNER = 5,
  TRADE = 6,
  AUCTION = 7,
  DEALERTRF = 8,
  VIP = 9,
  AGENCY = 10,
}
